export const FETCH_PORTFOLIOS_SEARCH_BEGIN="FETCH_PORTFOLIOS_SEARCH_BEGIN";
export const FETCH_PORTFOLIOS_SEARCH_SUCCESS="FETCH_PORTFOLIOS_SEARCH_SUCCESS";
export const FETCH_PORTFOLIOS_SEARCH_FAILURE="FETCH_PORTFOLIOS_SEARCH_FAILURE";


export const FETCH_PORTFOLIOS_BEGIN="FETCH_PORTFOLIOS_BEGIN";
export const FETCH_PORTFOLIOS_SUCCESS="FETCH_PORTFOLIOS_SUCCESS";
export const FETCH_PORTFOLIOS_FAILURE="FETCH_PORTFOLIOS_FAILURE";


export const FETCH_ASSETLIST_SEARCH_BEGIN="FETCH_ASSETLIST_SEARCH_BEGIN";
export const FETCH_ASSETLIST_SEARCH_SUCCESS="FETCH_ASSETLIST_SEARCH_SUCCESS";
export const FETCH_ASSETLIST_SEARCH_FAILURE="FETCH_ASSETLIST_SEARCH_FAILURE";


export const FETCH_ASSETLIST_BEGIN="FETCH_ASSETLIST_BEGIN";
export const FETCH_ASSETLIST_SUCCESS="FETCH_ASSETLIST_SUCCESS";
export const FETCH_ASSETLIST_FALURE="FETCH_ASSETLIST_FALURE";

export const FETCH_CURRENCYINFO_BEGIN="FETCH_CURRENCYINFO_BEGIN";
export const FETCH_CURRENCYINFO_SUCCESS="FETCH_CURRENCYINFO_SUCCESS";
export const FETCH_CURRENCYINFO_FAILURE="FETCH_CURRENCYINFO_FAILURE";


export const FETCH_GETENTITYRETURNS_BEGIN="FETCH_GETENTITYRETURNS_BEGIN";
export const FETCH_GETENTITYRETURNS_SUCCESS="FETCH_GETENTITYRETURNS_SUCCESS";
export const FETCH_GETENTITYRETURNS_FAILURE="FETCH_GETENTITYRETURNS_FAILURE";

export const FETCH_MANAGER_BEGIN = "FETCH_MANAGER_BEGIN";
export const FETCH_MANAGER_SUCCESS = "FETCH_MANAGER_SUCCESS";
export const FETCH_MANAGER_FAILURE = "FETCH_MANAGER_FAILURE";


export const FETCH_USERDETAILS_BEGIN = "FETCH_USERDETAILS_BEGIN";
export const FETCH_USERDETAILS_SUCCESS = "FETCH_USERDETAILS_SUCCESS";
export const FETCH_USERDETAILS_FAILURE = "FETCH_USERDETAILS_FAILURE";

export const FETCH_DS_BEGIN = "FETCH_DS_BEGIN";
export const FETCH_DS_SUCCESS = "FETCH_DS_SUCCESS";
export const FETCH_DS_FAILURE = "FETCH_DS_FAILURE";


export const FETCH_ENUM_BEGIN = "FETCH_ENUM_BEGIN";
export const FETCH_ENUM_SUCCESS = "FETCH_ENUM_SUCCESS";
export const FETCH_CONTACT_BEGIN = "FETCH_CONTACT_BEGIN";
export const FETCH_CONTACTLEAD_SUCCESS = "FETCH_CONTACTLEAD_SUCCESS";
export const FETCH_CONTACTRANK_SUCCESS = "FETCH_CONTACTRANK_SUCCESS";
export const FETCH_CONTACTREPTYPE_SUCCESS = "FETCH_CONTACTREPTYPE_SUCCESS";
export const FETCH_CONTACTUPDATESTATUS_SUCCESS = "FETCH_CONTACTUPDATESTATUS_SUCCESS";
export const FETCH_CONTACTCATEGORY_SUCCESS = "FETCH_CONTACTCATEGORY_SUCCESS";
export const FETCH_ENUM_FAILURE = "FETCH_ENUM_FAILURE";


export const FETCH_ACTIVEMENU_SUCCESS ='FETCH_ACTIVEMENU_SUCCESS';
export const FETCH_ACTIVESUBMENU_SUCCESS ='FETCH_ACTIVESUBMENU_SUCCESS';

export const FETCH_TAXENTITIES_BEGIN = "FETCH_TAXENTITIES_BEGIN";
export const FETCH_TAXENTITIES_SUCCESS = "FETCH_TAXENTITIES_SUCCESS";
export const FETCH_TAXENTITIES_FAILURE = "FETCH_TAXENTITIES_FAILURE";



export const FETCH_DEFAULTENTITIES_BEGIN="FETCH_DEFAULTENTITIES_BEGIN";
export const FETCH_DEFAULTENTITIES_SUCCESS="FETCH_DEFAULTENTITIES_SUCCESS";
export const FETCH_DEFAULTENTITIES_FAILURE="FETCH_DEFAULTENTITIES_FAILURE";

// LiquidityLockupFrequency

export const FETCH_LIQUIDITYREQUIREDNOTICE_BEGIN="FETCH_LIQUIDITYREQUIREDNOTICE_BEGIN";
export const FETCH_LIQUIDITYREQUIREDNOTICE_SUCCESS="FETCH_LIQUIDITYREQUIREDNOTICE_SUCCESS";
export const FETCH_LIQUIDITYREQUIREDNOTICE_FAILURE="FETCH_LIQUIDITYREQUIREDNOTICE_FAILURE";


export const FETCH_LIQUIDITYLOCKTYPE_BEGIN="FETCH_LIQUIDITYLOCKTYPE_BEGIN";
export const FETCH_LIQUIDITYLOCKTYPE_SUCCESS="FETCH_LIQUIDITYLOCKTYPE_SUCCESS";
export const FETCH_LIQUIDITYLOCKTYPE_FAILURE="FETCH_LIQUIDITYLOCKTYPE_FAILURE";



export const FETCH_LIQUIDITYLOCKUPFREQUENCY_BEGIN="FETCH_LIQUIDITYLOCKUPFREQUENCY_BEGIN";
export const FETCH_LIQUIDITYLOCKUPFREQUENCY_SUCCESS="FETCH_LIQUIDITYLOCKUPFREQUENCY_SUCCESS";
export const FETCH_LIQUIDITYLOCKUPFREQUENCY_FAILURE="FETCH_LIQUIDITYLOCKUPFREQUENCY_FAILURE";


export const FETCH_FREQUENCY_1_BEGIN="FETCH_FREQUENCY_1_BEGIN";
export const FETCH_FREQUENCY_1_SUCCESS="FETCH_FREQUENCY_1_SUCCESS";
export const FETCH_FREQUENCY_1_FAILURE="FETCH_FREQUENCY_1_FAILURE";


export const FETCH_FREQUENCY_2_BEGIN="FETCH_FREQUENCY_2_BEGIN";
export const FETCH_FREQUENCY_2_SUCCESS="FETCH_FREQUENCY_2_SUCCESS";
export const FETCH_FREQUENCY_2_FAILURE="FETCH_FREQUENCY_2_FAILURE";

// Families
export const FETCH_FAMILIES_BEGIN="FETCH_FAMILIES_BEGIN";
export const FETCH_FAMILIES_SUCCESS="FETCH_FAMILIES_SUCCESS";
export const FETCH_FAMILIES_FAILURE="FETCH_FAMILIES_FAILURE";


export const FETCH_STATES_BEGIN="FETCH_STATES_BEGIN";
export const FETCH_STATES_SUCCESS="FETCH_STATES_SUCCESS";
export const FETCH_STATES_FAILURE="FETCH_STATES_FAILURE";


export const FETCH_COUNTRY_BEGIN="FETCH_COUNTRY_BEGIN";
export const FETCH_COUNTRY_SUCCESS="FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILURE="FETCH_COUNTRY_FAILURE";